import { Link } from "react-router-dom";
import styled from "styled-components";
import React from "react";

function Cnfooter() {
  return (
    <footer id="valofe-footer" className="clearfix">
      <FooterCont>
        <p>
          健康游戏忠告：抵制不良游戏 拒绝盗版游戏 注意自我保护 谨防受骗上当
          适度游戏益脑 沉迷游戏伤身 合理安排时间享受健康生活
        </p>
        <p>
          <Link
            target="_blank"
            to="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010502030431"
          >
            <span className="small-logo" />
            <span>京公网安备11010502030431 </span>
          </Link>
          <Link
            to="http://web-cdn.xiyouxi.com/ICP/Internet-culture-license-20200722.pdf"
            target="_blank"
          >
            京网文【2018】11184-1022号
          </Link>
          文网进字[2011]028号 文网游进字[2016]0065号 文网游进字 【2016】0123 号
        </p>
        <p>
          <Link
            to="http://web-cdn.xiyouxi.com/ICP/2021_4_2_ICP_060370.pdf"
            target="_blank"
          >
            京ICP证060370号
          </Link>
          <Link to="https://beian.miit.gov.cn/" target="_blank">
            京ICP备11010177号-3
          </Link>
        </p>
        <p>
          纠纷邮箱 : service10@xiyouxiqj.com 北京喜游戏科技有限公司&nbsp;
          ©
          <span className="year-of-copyrights">
              {new Date().getFullYear()}
          </span>
          <Link to="http://xiyouxi.com/jzjh/index.html">
            未成年人家长监护制度
          </Link>
        </p>
        <div className="img-box">
          <img
            src="http://web-cdn.xiyouxi.com/xiyouxi/images/xiyouxi_logo_home.png"
            className="logo"
          />
          <div className="icon-box">
            <Link
              target="_blank"
              to="http://ccm.mct.gov.cn:80/ccnt/sczr/service/business/emark/gameNetTag/4028c08c4becb8aa014c077f1a352ee6"
            >
              <img
                src="http://web-cdn.xiyouxi.com/xiyouxi/images/foot_bazhu.png"
                className="link-logo"
              />
            </Link>
            <Link
              target="_blank"
              to="http://ccm.mct.gov.cn:80/ccnt/sczr/service/business/emark/gameNetTag/F35FC9BEF48B52AEE040007F01003007"
            >
              <img
                src="http://web-cdn.xiyouxi.com/xiyouxi/images/foot_bazhu.png"
                className="link-logo"
              />
            </Link>
            <Link target="_blank" to="http://ccm.mct.gov.cn/ccnt/sczr/login">
              <img
                src="http://web-cdn.xiyouxi.com/xiyouxi/images/foot_bazhu.png"
                className="link-logo"
              />
            </Link>
          </div>
        </div>
      </FooterCont>
    </footer>
  );
}

export default Cnfooter;

const FooterCont = styled.div`
  font-size: 0.7rem;
  text-align: center;
  margin-top: 1rem;

  a {
    display: inline-block;
    color: #fff;
  }

  p {
    padding-top: 0.08rem;
  }

  .small-logo {
    padding-left: 22px;
    background: url(http://web-cdn.xiyouxi.com/passport/images/gov_icp.png)
      no-repeat;
  }

  .img-box {
    padding-top: 1rem;
  }

  .logo {
    margin-right: 1rem;
  }

  .icon-box {
    display: inline-block;
  }

  .link-logo {
    width: 50px;
  }
`;
